__turbopack_context__.v({
  "header--search": "Search-module__Lg4wHG__header--search",
  "searchBar--searchPage": "Search-module__Lg4wHG__searchBar--searchPage",
  "searchBar__form": "Search-module__Lg4wHG__searchBar__form",
  "searchBar__icon": "Search-module__Lg4wHG__searchBar__icon",
  "searchBar__input": "Search-module__Lg4wHG__searchBar__input",
});
